module.exports = __webpack_public_path__ + "img/1-D-characterisation.ef72c8e2.png";